<template>
    <div class="px-4 2xl:px-8 h-full overflow-y-auto"
         :class="[{ 'no-empty': !selectsEmpty },{'bg-white': $widgetUI=='NEW-UI'}]">
        <your-selects/>

        <div v-if="savedListName" class="text-[20px] font-semibold">Copy of: {{ savedListName }}</div>

        <div v-if="!loading">
            <template v-if="items.length ">
                <template v-if="$widgetUI=='OLD-UI'">
                    <p class="text-[14px] text-gray-400 mb  -5 leading-snug" v-if="selectsEmpty">
                        The samples below will update from our live database, based on your selects.
                        Have questions? Visit our <a :href="$widgetConfig.faqUrl" target="_blank">FAQ</a> page.
                    </p>
                    <p class="text-[14px] text-gray-400 mb-5 leading-snug" v-else>
                        These are real samples from our database based on your selects.
                        Have questions? Visit our <a :href="$widgetConfig.faqUrl" target="_blank">FAQ</a> page.
                    </p>
                </template>
                <div class="overflow-auto max-h-[600px]" v-dragscroll>
                    <table class="w-full border-collapse table-auto">
                        <thead>
                        <tr>
                            <th v-for="(item, key) in labels"
                                :key="key"
                                class=" text-left p-2 lg:py-3 lg:px-6 text-[12px] lg:text-[14px]"
                                :class="$widgetUI=='OLD-UI'? 'text-primary font-normal':'text-black font-bold'"
                            >
                                {{ item }}
                            </th>
                        </tr>
                        </thead>
                        <tbody v-if="$widgetUI=='NEW-UI'">
                        <tr v-for="(item, index) in items"
                            :key="item.id">
                            <td v-for="(_item, _key) in item"
                                :key="_key"
                                class="font-normal text-left p-2 lg:py-3 lg:px-6 text-[12px] lg:text-[14px] whitespace-nowrap"
                                :class="{'bg-gray-100 ': index % 2 === 0}">
                                {{ _item }}
                            </td>
                        </tr>
                        </tbody>
                        <tbody v-else>
                        <tr v-for="(item, index) in items"
                            :key="item.id">
                            <td v-for="(_item, _key) in item"
                                :key="_key"
                                class="font-normal text-left p-2 lg:py-3 lg:px-6 text-[12px] lg:text-[14px] whitespace-nowrap"
                                :class="{'bg-white': index % 2 === 0}">
                                {{ _item }}
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </template>
            <template v-else>
                <div class="not-found-leads">
                    <h3 class="text-[16px]">No results were found in our database for your search</h3>
                    <p class="mb-0 leading-normal text-[12px]"
                       v-if="selectedData.audience === $widgetConfig.b2cBase">
                        Please select the geography tab and expand your geography, or look at your selects to make
                        sure they're not in conflict. For example, if you chose "Household with Child Approaching
                        High School Graduation" and "Age 22-25", expect the count to be 0. If you are looking for
                        leads of households with children approaching high school graduation and leads of people
                        between the ages of 22 and 25, that would have to be placed as two separate orders.
                    </p>
                    <p class="mb-0 leading-normal text-[12px]" v-else>
                        Please select the geography tab and expand your geography, or look at your selects to make
                        sure they're not in conflict. For example, if you chose "Annual Sales $500 Million to
                        $1 Billion" and "Number of Employees 1-10", expect the count to be 0. If you are looking
                        for leads of companies with annual sales from $500 million to $1 billion and leads from
                        companies from 1-10 employees, that would have to be placed as two separate orders.
                    </p>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import YourSelects from "@widget/components/your-selects";

export default {
    name: "fake-leads",
    components: {
        YourSelects
    },
    computed: {
        selectedData () {
            return this.$store.getters["widgetData/selectedData"];
        },
        selectsEmpty () {
            return !this.selectedData.selects.length;
        },
        loading () {
            return this.$store.getters["fakeLeads/getLoading"];
        },
        labels () {
            return this.$store.getters["fakeLeads/getData"].labels;
        },
        items () {
            return this.$store.getters["fakeLeads/getData"].items;
        },
        savedListName () {
            if (this.$widgetConfig.savedList) {
                return this.$widgetConfig.savedList.title;
            }
            return null;
        }
    },
    watch: {
        selectedData: {
            handler () {
                this.getLeads();
            },
            deep: true
        }
    },
    methods: {
        getLeads () {
            this.$store.dispatch("fakeLeads/getList");
        }
    },
    created () {
        this.getLeads();
    }
};
</script>
